export default () => ({
  allSports: [],
  allFirstLetters: {
    all: [],
    firstLast: ''
  },
  socialNetworks: []
})
